<template>
  <div :style="[customCss]">
    <div class="flex body-text-color flex-col items-center mb-5">
      <div
        class="flex flex-col justify-center h-10"
        :style="
          'height:' + themeSettings.configuration_options.logo_slider + 'px'
        "
      >
        <img
          class="h-full"
          :src="themeSettings.configuration_options.logo_image"
        />
      </div>
      <div class="text-2xl font-bold mb-3">
        {{ themeSettings.configuration_options.title }}
      </div>

      <div class="text-sm">
        {{ themeSettings.configuration_options.description }}
      </div>
    </div>
    <div>
      <span class="text-red" v-if="!message.success">{{ message.string }}</span>
      <div class="mb-8">
        <p class="text-dark text-sm body-text-label-color font-semibold mb-2">
          Email
        </p>
        <text-input
          class="body-input-field-border-color"
          :placeholder="$t('frontend_groovemember_form_placeholder_email')"
          v-model="form.email"
          required
        />
      </div>
      <div class="mb-8">
        <p class="text-dark text-sm body-text-label-color font-semibold mb-2">
          {{ $t('frontend_groovemember_form_password') }}
        </p>
          <input
            type="password"
            class="w-full relative h-10 text-grey-600 border border-solid border-grey-200 rounded-lg bg-white body-input-field-border-color px-4"
            :placeholder="$t('frontend_groovemember_form_placeholder_password')"
            v-model="form.password"
            required
          />
        </div>        
      </div>
      <gd-button
        size="auto"
        class="w-full body-button-text-color body-button-color h-12 px-4 btn-radius text-base font-semibold"
        @click="login(form)"
      >
        {{ themeSettings.gen_settings.sign_in_now_txt }} <span v-if="spinloader"><i class="fa fa-spinner fa-spin ml-3"></i></span>
      </gd-button>
      
        <div class="w-full flex flex-row mt-2">
            <div class="flex w-1/2 flex-row">
                <span
                    @click="
                    backToHome({
                        name: 'home',
                        params: {},
                    })" class="text-dark cursor-pointer  text-center text-sm body-forgot-message-color font-semibold">{{ themeSettings.gen_settings.back_to_home_txt }}</span>
            </div>
            <div class="flex flex-row justify-end items-end w-1/2">
                <div
                class="flex justify-end items-end body-forgot-message-color text-sm text-pink font-semibold cursor-pointer"
                @click="backToHome({name: 'password.request',params: {},})">
                    {{ themeSettings.gen_settings.forgot_password_txt }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import TextInput from '@groovepages/gd-ui-kit/components/TextInput';

export default {
  name: 'Form',
  data() {
    return {
      form: {
        email: '',
        password: '',
        membership_id: '',
      },
    };
  },
  props: {
    getThemeSettings: {},
    backToHome: {
      type: Function,
      default: () => {},
    },
    forgotPass: {
      type: Function,
      default: () => {},
    },
    login: {
      type: Function,
      default: () => {},
    },
    message: {
      type: Object,
      default: () => {
        return { success: true, string: '' };
      },
    },
    spinloader: {
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },
  components: {
    GdButton,
    TextInput,
  },
  computed: {
    customCss() {
      return {
        '--template-text-color': this.themeSettings.body_section.text_color,
        '--template-text-label-color': this.themeSettings.body_section
          .text_label_color,
        '--template-border-color-input-fields': this.themeSettings.body_section
          .border_color_input_fields,
        '--template-button-color': this.themeSettings.body_section.button_color,
        '--template-button-text-color': this.themeSettings.body_section
          .button_text_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss">
@import '../../../../assets/css/campton_font.css';

.full-tile-hover {
  .tile-wrapper {
    position: relative;
    .relative {
      position: static;
    }
  }
}

.body-bg-color {
  background-color: var(--template-bg-color);
}

.body-text-color {
  color: var(--template-text-color);
}

.body-text-label-color {
  color: var(--template-text-label-color);
}

.body-input-field-border-color {
  border-color: var(--template-border-color-input-fields);
}

.body-button-color {
  background-color: var(--template-button-color);
  border-color: var(--template-button-color);
}

.body-button-text-color {
  color: var(--template-button-text-color) !important;
}

.body-forgot-message-color {
  color: var(--template-button-color);
}
</style>